import { createStore } from "@tanstack/react-store";
import type {
  TNotificationStore,
  TPushNotification,
  TNotificationStoreDispatch,
} from "./notifications.config";

export const notificationsStore = createStore<TNotificationStore>({
  notifications: [],
});

export const notificationsDispatch: TNotificationStoreDispatch = {
  pushNotification: (notification: TPushNotification): string => {
    const id = crypto.randomUUID();

    notificationsStore.setState((state) => ({
      ...state,
      notifications: [
        ...state.notifications,
        {
          ...notification,
          id,
        },
      ],
    }));

    return id;
  },
  removeNotification: (id: string): void => {
    notificationsStore.setState((state) => ({
      ...state,
      notifications: state.notifications.filter(
        (notification) => notification.id !== id,
      ),
    }));
  },
};
